import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { OptionsBaseContainer, OptionsRow } from './RecurrenceOptions.styled'
import {
  OnUpdateOptions,
  dayOfTheWeekSelectOptions,
  DayOfTheWeekValue,
} from '../types'

type WeeklyOptionsProps = {
  onUpdateOptions: OnUpdateOptions
  dayOfWeek: DayOfTheWeekValue
}

export const WeeklyOptions = ({
  onUpdateOptions,
  dayOfWeek,
}: WeeklyOptionsProps) => (
  <OptionsBaseContainer>
    <OptionsRow>
      <FormControl fullWidth>
        <InputLabel id='task-modal-v2-weekly-on-day-select-label'>
          On*
        </InputLabel>
        <Select
          labelId='task-modal-v2-weekly-on-day-select-label'
          id='task-modal-v2-weekly-on-day-select'
          onChange={({ target }) =>
            onUpdateOptions({
              key: 'dayOfWeek',
              value: target.value as DayOfTheWeekValue,
            })
          }
          sx={{ width: '100%' }}
          value={dayOfWeek}
        >
          {dayOfTheWeekSelectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </OptionsRow>
  </OptionsBaseContainer>
)
